import {
  EditIcon,
  EyeIcon,
  KeyIcon,
  UserMinusIcon,
  UserPlusIcon,
} from "assets";
import { CustomTooltip, MediumScreenModel, SmallScreenModel } from "components";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import HandleUpdateCommercialUser from "../manage_commercial_user/HandleUpdateCommercialUser";
import { CommercialUserProps } from "../../state/actionType";
import HandleUpdateCommercialUserStatus from "../manage_commercial_user/HandleUpdateCommercialUserStatus";
import { CommercialUserStatus } from "props/enum";
import HandleResetCommercialPassword from "../manage_commercial_user/HandleResetCommercialPassword";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../../../../props/enum';

const ActionButton: React.FC<{ items: CommercialUserProps }> = ({ items }) => {
  const [isEditModel, setEditModel] = useState(false);
  const [isUpdateStatus, setIsUpdateStatus] = useState(false);
  const [isPassword, setIsPassword] = useState(false);
  const navigate = useNavigate();
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.UPDATE_COMMERCIAL_USER));
  if (isPermitted)
    return (
      <>
        <div className="flex flex-row gap-2 justify-center">
          <CustomTooltip title="Preview user detail" placement="bottom">
            <button
              className="hover:text-primary-900"
              onClick={() =>
                navigate(
                  `/user_mamagement/commercial_user/user/${items.id.toString()}`,
                  {
                    state: { commercialUserData: items },
                  }
                )
              }
            >
              <EyeIcon />
            </button>
          </CustomTooltip>
          <CustomTooltip title="Edit user detail" placement="bottom">
            <button
              className="hover:text-primary-900"
              onClick={() => setEditModel(true)}
            >
              <EditIcon />
            </button>
          </CustomTooltip>
          <CustomTooltip title="Change Password" placement="bottom">
            <button
              className="hover:text-primary-900"
              onClick={() => setIsPassword(true)}
            >
              <KeyIcon />
            </button>
          </CustomTooltip>
          <CustomTooltip
            title={`${
              items.status === CommercialUserStatus.Active
                ? "Delete user"
                : "Active user"
            }`}
            placement="bottom"
          >
            <button
              className="hover:text-primary-900"
              onClick={() => setIsUpdateStatus(true)}
            >
              {items.status === CommercialUserStatus.Active ? (
                <UserMinusIcon className="size-5 text-primary-500 hover:text-primary-700" />
              ) : (
                <UserPlusIcon className="size-5 text-red-500 hover:text-red-700" />
              )}
            </button>
          </CustomTooltip>
          {isEditModel && (
            <MediumScreenModel
              setShowModal={setEditModel}
              showModal={isEditModel}
            >
              <HandleUpdateCommercialUser
                onClose={() => setEditModel(false)}
                commercialUserData={items}
              />
            </MediumScreenModel>
          )}
          {isUpdateStatus && (
            <SmallScreenModel
              setShowModal={setIsUpdateStatus}
              showModal={isUpdateStatus}
            >
              <HandleUpdateCommercialUserStatus
                onClose={() => setIsUpdateStatus(false)}
                commercialUserData={items}
              />
            </SmallScreenModel>
          )}
          {isPassword && (
            <SmallScreenModel
              setShowModal={setIsPassword}
              showModal={isPassword}
            >
              <HandleResetCommercialPassword
                onClose={() => setIsPassword(false)}
                commercialUserData={items}
              />
            </SmallScreenModel>
          )}
        </div>
      </>
    );
  return <></>;
};
export default ActionButton;
